import { ErrorResponse, ServerError } from '~/infra/error-response/ErrorResponse';
export var StanfordTaxConnectFailureSurface = /*#__PURE__*/ function(StanfordTaxConnectFailureSurface) {
    StanfordTaxConnectFailureSurface["Field"] = "field";
    StanfordTaxConnectFailureSurface["Notification"] = "notification";
    return StanfordTaxConnectFailureSurface;
}({});
export var StanfordTaxConnectFieldError = /*#__PURE__*/ function(StanfordTaxConnectFieldError) {
    StanfordTaxConnectFieldError["IdentifierMalformed"] = "identifierMalformed";
    StanfordTaxConnectFieldError["FirmNotFound"] = "firmNotFound";
    StanfordTaxConnectFieldError["FirmNotActive"] = "firmNotActive";
    return StanfordTaxConnectFieldError;
}({});
const fieldErrors = [
    {
        serverError: ServerError.StanfordTaxFirmIdentifierMalformed,
        reason: "identifierMalformed"
    },
    {
        serverError: ServerError.StanfordTaxFirmNotFound,
        reason: "firmNotFound"
    },
    {
        serverError: ServerError.StanfordTaxFirmNotActive,
        reason: "firmNotActive"
    }
];
export const classifyStanfordTaxConnectFailure = (error)=>{
    const response = new ErrorResponse(error);
    const fieldError = fieldErrors.find((param)=>{
        let { serverError } = param;
        return response.hasServerError(serverError);
    });
    return fieldError != null ? {
        surface: "field",
        reason: fieldError.reason
    } : {
        surface: "notification"
    };
};
